import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { PrintDocument } from "../../../models/print-document";
import { PrintDocumentControllerService } from "../../../services/print-document/print-document-controller.service";
import { PrintDocumentService } from "../../../services/print-document/print-document.service";
import { BaseError } from "../base-error";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {Context} from "../../../models/context";
import {ServiceDetailComponent} from "../service-detail/service-detail.component";

@Component({
  selector: "app-doc-builder",
  templateUrl: "./print-documents.html",
  styleUrls: ["./print-documents.scss"],
  providers: [PrintDocumentControllerService],
})
export class PrintDocumentsComponent extends TranslatedBaseError implements OnInit {

  @ViewChild("serviceDetailRef") public serviceDetailComponent: ServiceDetailComponent;
  @Input() public parentServiceDetail?: ServiceDetailComponent;
  @Input() public useServiceDetailWrapper: boolean = true;
  @Input() public pageLocation: string = "header.prints_builder";

  @Input() public serviceId: string;
  @Input() public serviceName: string;
  @Input() public determinantMapById: { [key: string]: string };
  public baseUrl: string;
  public showTemplatesList: boolean = false;
  public showPrintDocumentAdd: boolean = false;
  @Input() public context: Context = new Context();
  public templateId: string;
  public searchValue: string;

  @Input() public hideList: boolean = false;

  public subscription: any;

  public printDocuments: PrintDocument[];
  public activePrintDocuments: PrintDocument[];
  public printTemplateList: any;

  // hack - angular does not support routerlinks properly

  constructor(private printDocController: PrintDocumentControllerService,
              private printDocService: PrintDocumentService,
              private route: ActivatedRoute, toastr: ToastrService,
              public translateService: TranslateService) {

      super(toastr, translateService);
    }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/print-documents";
    });
    this.getDocumentList();
    this.subscription = this.printDocService.changed.subscribe((event: any) => {
      if (event.change) {
        this.getDocumentList();
      }
    });
    this.getTemplateList();
  }

  public getDocumentList() {
    this.printDocController.getDocumentList(this.serviceId, false).subscribe(
      (data) => {
        this.printDocuments = data;
      },
    );
  }

  public getTemplateList() {
    this.printDocController.getTemplatesList().subscribe(
      (data) => {
        this.printTemplateList = data;
      },
    );
  }

  public updateSearch(event) {
    this.searchValue = event;
  }

  public toggleOperational(printDocument: any) {
    printDocument.isLoading = true;
    printDocument.active = !printDocument.active;
    this.printDocController.saveDocument(printDocument).subscribe(
      () => {
        printDocument.isLoading = false;
        if (printDocument.active) {
          this.responseSuccessful("Document activated!");
        } else {
          this.responseSuccessful("Document inactivated!");
        }
      },
      (error) => {
        this.getDocumentList();
        return this.showErrorMessage(error);
      },
    );
  }

  public sortDocuments(printDocuments: PrintDocument[]) {
    this.printDocController.updateSortOrder(printDocuments).subscribe(
      () => {
        this.printDocuments = printDocuments;
        this.responseSuccessful("Documents reordered!");
      },
      (error) => {
        this.getDocumentList();
        return this.showErrorMessage(error);
      },
    );
  }

  public deleteDocument(doc: any) {
    this.printDocController.deleteDocument(doc.id).subscribe(
      () => {
        this.responseSuccessful("Document deleted!");
        this.getDocumentList();

      },
      (error) => this.showErrorMessage(error),
    );

  }

  public closeLayer() {
    this.showPrintDocumentAdd = false;
    this.templateId = undefined;
  }

  public addedCertificate() {
    this.closeLayer();
    this.getDocumentList();
  }

  private getServiceDetail(): ServiceDetailComponent {
    return this.parentServiceDetail ?? this.serviceDetailComponent;
  }

  public onServiceTutorialSaved() {
    const detail = this.getServiceDetail();
    if (detail) {
      detail.updateService();
    }
  }

  public selectedTemplate(id: string) {
    this.templateId = id;
  }

}
